"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSearchLocation = exports.getAllLocationCrimes = exports.formatAllCrimesResponse = exports.AllCrimeData = exports.CrimeData = void 0;
// TODO ^^^ fix these disables ^^^
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const applySpec_1 = __importDefault(require("ramda/src/applySpec"));
const defaultTo_1 = __importDefault(require("ramda/src/defaultTo"));
const F_1 = __importDefault(require("ramda/src/F"));
const groupBy_1 = __importDefault(require("ramda/src/groupBy"));
const isEmpty_1 = __importDefault(require("ramda/src/isEmpty"));
const isNil_1 = __importDefault(require("ramda/src/isNil"));
const path_1 = __importDefault(require("ramda/src/path"));
const pluck_1 = __importDefault(require("ramda/src/pluck"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const remove_1 = __importDefault(require("ramda/src/remove"));
const errorLogging_1 = require("../thirdparty/errorLogging");
const api_1 = require("./api");
/**
   * TODO: Later need to check whether this needs to be moved to component and to get title dynamically from cententful.
   *
   * This is used in component to render the crime title with respective color code when location is searched for getting crime info.
   * The count is fetched from All Crime API response and formatted in select.ts.
   */
exports.CrimeData = [
    {
        color: 'neutralLightRed',
        count: '0',
        key: 'burglary',
        title: 'BURGLARY'
    },
    {
        color: 'brandPrimary',
        count: '0',
        key: 'criminal-damage-arson',
        title: 'CRIMINAL DAMAGE AND ARSON'
    },
    {
        color: 'neutralLightBrown',
        count: '0',
        key: 'anti-social-behaviour',
        title: 'ANTI-SOCIAL BEHAVIOUR'
    },
    {
        color: 'accentTan',
        count: '0',
        key: 'bicycle-theft',
        title: 'BICYCLE THEFT'
    },
    {
        color: 'neutralDarkGray',
        count: '0',
        key: 'other-theft',
        title: 'OTHER THEFT'
    }
];
/**
   * TODO: Later need to check whether this needs to be moved to component.
   *
   * This is used for generating all location crimes table comparison during build time by gatsby-node.js.
   */
exports.AllCrimeData = [
    {
        color: '',
        count: '0',
        key: '',
        title: 'UK CITIES'
    },
    {
        color: '',
        count: '0',
        key: '',
        title: 'TOTAL'
    },
    {
        color: '',
        count: '0',
        key: 'burglary',
        title: 'BURGLARIES'
    },
    {
        color: '',
        count: '0',
        key: 'bicycle-theft',
        title: 'BICYCLE THEFT'
    },
    {
        color: '',
        count: '0',
        key: 'other-theft',
        title: 'OTHER THEFT'
    },
    {
        color: '',
        count: '0',
        key: 'criminal-damage-arson',
        title: 'ARSON & VANDALISM'
    },
    {
        color: '',
        count: '0',
        key: 'anti-social-behaviour',
        title: 'ANTI-SOCIAL BEHAVIOUR'
    }
];
/**
 * @package
 */
const toCrimeCategory = (0, applySpec_1.default)({ category: (0, prop_1.default)('category') });
/**
 * @package
 */
const dispatchSuccess = (results, location, dispatch) => {
    const action = {
        '@@type': 'ukPoliceData',
        payload: { [location]: results, },
        type: 'SET_POLICEDATA_LOCATION'
    };
    dispatch(action);
};
/**
 * This is used for formatting all location crimes table comparison during build time by gatsby-node.js.
 * @package
 */
// TODO the police data types need to be defined and most of these functions need to be refactored
// It's hard to understand what most of this is doing
// TODO: create a type for 'resp' and create a mock file with correctly typed data
const formatAllCrimesResponse = (resp) => ({
    body: resp.map(value => {
        // TODO: Need to revisit this any type shortly.
        // @ts-ignore
        const x = Object.values(value)[0] || [];
        // @ts-ignore // TODO: fix the type of "x"
        const payload = x.filter(v => v.isRight())
            .map(v => v.right())
            .flat()
            .map(v => toCrimeCategory(v));
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const crimesByCategory = (0, groupBy_1.default)((0, prop_1.default)('category'))(payload);
        const result = !(0, isEmpty_1.default)(crimesByCategory) ? exports.AllCrimeData.map((crimeInfo) => {
            const categoryCrime = crimesByCategory[crimeInfo.key];
            return (!(0, isNil_1.default)(categoryCrime) && !(0, isEmpty_1.default)(categoryCrime) && categoryCrime.length) || 0;
        }) : [];
        const total = (0, reduce_1.default)((acc, item) => acc + item, 0)(result);
        const resp = result.map(new Intl.NumberFormat().format);
        // TODO: remove the unshift and don't mutate data
        // @ts-ignore
        // eslint-disable-next-line functional/immutable-data
        resp.unshift(Object.keys(value)[0] || '', new Intl.NumberFormat().format(total));
        // Removing UK CITIES & TOTAL entries from response array.
        return (0, remove_1.default)(2, 2, resp);
    }),
    head: (0, pluck_1.default)('title')(exports.AllCrimeData)
});
exports.formatAllCrimesResponse = formatAllCrimesResponse;
/**
 * @package
 */
const getCoordinates = (geoLocation) => (0, defaultTo_1.default)([])((0, path_1.default)(['features', 0, 'geometry', 'coordinates'], geoLocation));
/**
 * To make Police Data API Call for getting location based crimes details.
 *
 * @param coordinate - Get from Mapbox API
 * @param dates -> [YYYY-MM] date format
 * @param noOfParallel -> To make no of parallel calls at the same time.
 *
 * @example getCrimesByLocation([-1.61333, 54.97778], ['2020-11', 2020-10'], 3)
 *
 * The above code will make 2 Police Data API call as follows
 *
 * 1. https://data.police.uk/api/crimes-street/all-crime?lat=54.97778&lng=-1.61333&date=2020-11
 * 2. https://data.police.uk/api/crimes-street/all-crime?lat=54.97778&lng=-1.61333&date=2020-10
 */
const getCrimesByLocation = (coordinate, dates, noOfParallel = 6) => (0, fluture_1.parallel)(noOfParallel)(dates.map((date) => (0, fluture_1.coalesce)((leftResp) => (0, monet_1.Left)(leftResp))((rightResp) => (0, monet_1.Right)(rightResp.orUndefined()))((0, api_1.getCrimesByLocationRequest)(coordinate, date))));
/**
 * This is used for getting all location crimes table info during the build time in gatsby-node.js.
 *
 * @param locations
 * @param dates
 * @param noOfParallel
 *
 * @example await getAllLocationCrimes(['derby', 'london'], ['2020-11', 2020-10'])
 */
const getAllLocationCrimes = async (locations, dates, noOfParallel = 3) => {
    return await locations.map(async (loc) => {
        return {
            // @ts-ignore - TODO: To remove this ignore once E2E integrtaion done for this feature.
            [loc]: await (0, fluture_1.promise)(((0, api_1.searchLocationRequest)(loc))).then(async (resp) => {
                const coordinates = resp.fold([])(value => getCoordinates(value));
                return await (0, fluture_1.promise)(getCrimesByLocation(coordinates, dates, noOfParallel));
            })
        };
    });
};
exports.getAllLocationCrimes = getAllLocationCrimes;
/**
   * Fetches location using mapbox source then use coordinates to fetch crimes using external police data source.
   * TODO: convert this to a redux thunk so it can be run with `dispatch(IOSearchLocation(location, dates))`, and remove `IO` wrapper
   *
   * @example
   * const dispatch = useDispatch()
   *
   * useEffect(() => {
   *   IOSearchLocation(dispatch)('london').run()
   * }, [ dispatch ])
   */
const IOSearchLocation = (dispatch) => (location, dates) => (0, monet_1.IO)(() => {
    return (0, api_1.searchLocationRequest)(location)
        .pipe((0, fluture_1.map)((resp) => {
        const coordinates = resp.fold([])(value => getCoordinates(value));
        (0, fluture_1.fork)(F_1.default)((res) => {
            const payload = res.filter(v => v.isRight())
                .map(v => v.right())
                .flat()
                .map(v => toCrimeCategory(v));
            dispatchSuccess(payload, location, dispatch);
            return payload;
        })(getCrimesByLocation(coordinates, dates));
        return resp;
    }))
        .pipe((0, fluture_1.fork)((x) => {
        const action = {
            '@@type': 'ukPoliceData',
            payload: monet_1.Maybe.fromNull(x),
            type: 'SET_POLICEDATA_ERROR'
        };
        dispatch(action);
        (0, errorLogging_1.logError)(x);
    })(res => res.forEach(x => {
        const action = {
            '@@type': 'ukPoliceData',
            payload: x,
            type: 'SET_POLICEDATA_GEOLOCATION'
        };
        dispatch(action);
    })));
});
exports.IOSearchLocation = IOSearchLocation;
//# sourceMappingURL=policedata.js.map